import axios from "axios"
import { URL } from "./settings"

export default class UsersService {
    static async getMyself() {
        try {
            const response = await axios.get(`${URL}/user/me/`, {
                withCredentials: true
            })
            console.log("UserService::getMyself response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async updateMyself(data) {
        try {
            const response = await axios.put(`${URL}/user/me/`, data, {
                withCredentials: true
            })
            console.log("UserService::updateMyself response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async getUsers(query) {
        try {
            const response = await axios.get(`${URL}/user/`, {
                params: query,
                withCredentials: true
            })
            console.log("UserService::getUsers response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async updateUser(user_id, data) {
        try {
            const response = await axios.patch(`${URL}/user/`, data, {
                params: { user_id: user_id },
                withCredentials: true
            })
            console.log("UserService::updateUser response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async getContexts() {
        try {
            const response = await axios.get(`${URL}/context/`)
            console.log("UserService::getContexts response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async changeActiveContext(contextId) {
        try {
            const response = await axios.post(`${URL}/user/me/active_context`,
                { active_context_id: contextId },
                { withCredentials: true }
            )
            console.log("UserService::changeActiveContext response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }
}
